
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';import { apiService } from '../../constants/ApiService';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { resetToken } from '../../reducetool/features/authSlice';
import { allRemoveItem } from '../../reducetool/features/cardSlice';
import InfoModal from './InfoModal';

const AllRewards = () => {
    const authData = useSelector(state => state.authState);

    const navigate = useNavigate();
    const location = useLocation();
    const [userDetail, setUserDetail] = useState(authData.user);
    const [rewardCardList, setRewardCardList] = useState([]);

    const [isViewInfo, setIsViewInfo] = useState(false);

    const [contributorInfo, setContributorInfo] = useState({});
   
    const getRewardCardList = async (level) => {

        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/TreeTesting/GetUserRewadCards?userMob=${userDetail.user_mobile}&level=${level}`, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }

            console.log(response)

            if (response.status === true) {
                setRewardCardList(response.rewardCardDataList);
            }
            else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    }

    useEffect(() => {

        if (authData.login) {
            
            console.log(location.state.level)
            getRewardCardList(location.state.level)
        }
    }, []);

    const handleInfoClose = () => {
        setIsViewInfo(false);
        //document.body.classList.remove("modal-open-blur");
    };

    const onHanldeLevelInfo = (data) => {
        setIsViewInfo(true);
        setContributorInfo(data);
        //document.body.classList.add("modal-open-blur");
    }

    
    return(
        <>
            <section className="user-dashboard-section section-b-space">
                    <div className="container-fluid-lg">
                        <div className="row">
                            <div className="col-xxl-12 col-lg-12">  
                            <div className="dashboard-card">
                                            <div className="title title-flex">
                                                <div>
                                                    <h2>My Reward Details</h2>
                                                    <span className="title-leaf">
                                                        <svg className="icon-width bg-gray">
                                                            <use xlinkHref="../assets/svg/leaf.svg#leaf" />
                                                        </svg>
                                                    </span>
                                                </div>
                                            </div>


                                            <div className="row g-4">

                                            {rewardCardList.length? rewardCardList.map((item) => {
                                                    return (
                                                        <>
                                                            <div className="col-xxl-12 col-xl-12 col-lg-12 col-sm-12">
                                                                <div className="seller-grid-box seller-grid-box-1 shadow-lg mb-0">
                                                                    <i className="fa fa-info-circle float-end" onClick={onHanldeLevelInfo.bind(this, item.pointContributorsList)}></i>

                                                                    <div className="grid-image">
                                                                        <div className="image">
                                                                            <img
                                                                                src="../assets/images/vendor-page/logo/2.png"
                                                                                className="img-fluid"
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                        <div className="contain-name">
                                                                            <div>
                                                                                {/* <div className="since-number">
                                                                                    <h6>Reward Card no.</h6>
                                                                                </div> */}
                                                                                <h3>Worth ₹{item.lv_completion_amt} Reward</h3>
                                                                                {/* <h3>{item.reward_msg}</h3> */}
                                                                            </div>
                                                                            <div class="progress mb-2">
                                                                                <div class="progress-bar" role="progressbar" style={{ width: `${item.level_progress_percent}%`, backgroundColor: "#0da487" }} aria-valuenow={item.level_progress_percent} aria-valuemin="0" aria-valuemax="100">{item.level_progress_percent}%</div>
                                                                            </div>
                                                                            <label className="product-label">Reward Card no. {item.reward_card_no}</label>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>



                                                        </>)
                                                })
                                            
                                            : (<> 
                                             <div className="col-xxl-12 col-xl-12 col-lg-12 col-sm-12">
                                                                <div className="seller-grid-box seller-grid-box-1 shadow-lg mb-0">
                                                                    <i className="fa fa-info-circle float-end"></i>

                                                                    <div className="grid-image">
                                                                        <div className="image">
                                                                            <img
                                                                                src="../assets/images/vendor-page/logo/2.png"
                                                                                className="img-fluid"
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                        <div className="contain-name">
                                                                            <div>
                                                                                <div className="since-number">
                                                                                    <h6>Reward Card no.</h6>
                                                                                </div>
                                                                                <h3>3343</h3>
                                                                            </div>
                                                                            <div class="progress mb-2">
                                                                                <div class="progress-bar" role="progressbar" style={{ width: '25%', backgroundColor: "#0da487" }} aria-valuenow="25%" aria-valuemin="0" aria-valuemax="100">25%</div>
                                                                            </div>
                                                                            <label className="product-label">345 / 18000 Shiv Coins Earned</label>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                            <h4 className='text-center'> No reward cards present at this moment. Continue Shopping to generate them soon</h4></>)}

                                              
                                                </div>

                                        </div>
                            </div> 
                        </div>
                    </div>
            </section>
            {isViewInfo &&
                <InfoModal
                    contributorInfo={contributorInfo}
                    handleInfoClose={handleInfoClose} />
            }
        </>)
}

export default AllRewards;